export default "__VITE_ASSET__Bwu8na0m__"